import { render, staticRenderFns } from "./slideComponent.vue?vue&type=template&id=f8de7cda&scoped=true&"
import script from "./slideComponent.vue?vue&type=script&lang=js&"
export * from "./slideComponent.vue?vue&type=script&lang=js&"
import style0 from "./slideComponent.vue?vue&type=style&index=0&id=f8de7cda&prod&lang=scss&scoped=true&"
import style1 from "./slideComponent.vue?vue&type=style&index=1&id=f8de7cda&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8de7cda",
  null
  
)

export default component.exports